import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import { instance } from "Actions/AxiosInstance";
import deleteicon from "Assets/Icons/Actions/delete-bin-outline-16-px.svg";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DrawerHeader from "Component/Headers/drawerHeader";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import Create from "./create";

let shouldCallAPI = true;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allemployees: [],
      permissions: { editable: true, readonly: true },
      listdata: [],
      offset: 0,
      limit: 20,
      fullcount: 1,
      value: 0,
      data: false,
      postData: null,
      copypolicy: null,
      nofuel: false,
      selectedRow: null,
      ishiringmanager: false,
      right: false,
      ispipeline: false,
      open: false,
      issearch: false,
      newpolicycreate: false,
      headers: [
        {
          key: "name",
          name: "Hiring plan name",
          style: { textAlign: "left" },
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
        },
        // {
        //   key: "designationname",
        //   name: "Number of requisitions",
        //   style: { textAlign: "left" },
        //   type: TDTypeConsts.OTHERS,
        // },
        {
          key: "addedbyname",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "owner",
          name: "Plan owner",
          type: TDTypeConsts.ASSIGNED_USER_LIST,
        },
        {
          key: "hiringmanager",
          name: "Hiring managers",
          type: TDTypeConsts.ASSIGNED_USER,
        },
        // {
        //   key: "pipeline",
        //   name: "Pipeline",
        //   style: { textAlign: "left" },
        //   type: TDTypeConsts.OTHERS,
        // },

        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getAllHiringPlan = this.getAllHiringPlan.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.onCreate = this.onCreate.bind(this);
    // this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.editHiringMangers = this.editHiringMangers.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.searchHiring = this.searchHiring.bind(this);
    this.handleScroll1 = this.handleScroll1.bind(this);
    // this.getAllEmp = this.getAllEmp.bind(this);
  }

  componentDidMount() {
    if (
      this.props.isrecruiter ||
      this.props.ishiringowner ||
      this.props.ishiringmanager
    ) {
      window.addEventListener("scroll", this.handleScroll1);
      this.getAllHiringPlan(false);
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  searchHiring(e) {
    const { backupList, listdata } = this.state;
    const filterList = listdata.filter(
      (item) =>
        item.name.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      issearch: e.target.value ? true : false,
      searchValue: e.target.value,
      listdata: e.target.value ? filterList : backupList,
      isdata: filterList.length == 0 ? true : false,
    });
  }

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      hiringplanid: selectedRow.hiringplanid ? selectedRow.hiringplanid : null,
      isactive: value == 1 ? true : false,
    };

    this.props.enqueueSnackbar(
      "Are you sure you want to change status of this hiring plan?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              // const { selectedRow } = this.state;
              this.props.closeSnackbar();
              instance
                .post("recruit/activeinactivethiringplan", data)
                .then((res) => {
                  this.setState(
                    {
                      offset: 0,
                      fullcount: 1,
                    },
                    () => this.getAllHiringPlan(true),
                  );
                });
            }}
          >
            Yes
          </Button>,

          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  };

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "ispipeline") {
      this.setState({
        ispipeline: true,
        ishiringmanager: false,

        [side]: open,
      });
    } else if (flag === "ishiringmanager") {
      this.setState({
        ishiringmanager: true,
        ispipeline: false,

        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        [side]: open,
        expanded: false,
        ishiringmanager: false,
        ispipeline: false,
      });
    }
  };

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/hiring_plan`);
    }
    window.removeEventListener("scroll", this.handleScroll1);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll1);
  }

  editHiringMangers() {
    this.setState({
      ishiringmanager: !this.state.ishiringmanager,
      right: true,
      ispipeline: false,
    });
  }

  handleScroll1() {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (this.state.fullcount > this.state.offset) {
        this.getAllHiringPlan(false);

        setTimeout(() => {
          shouldCallAPI = true;
        }, 2000);
      }
    }
  }

  getAllHiringPlan(isRefresh = false) {
    const { listdata } = this.state;
    if (isRefresh) {
      this.setState({
        fullcount:
          this.state.listdata.length == 0 ? 1 : this.state.listdata[0].count,
        offset: this.state.listdata.length == 0 ? 0 : this.state.offset,
      });
    }

    if (shouldCallAPI) {
      if (this.state.offset < this.state.fullcount) {
        shouldCallAPI = false;
        instance
          .post(`recruit/getallhiringplan`, {
            isactive: true,
            limit: this.state.limit,
            offset: this.state.offset,
            isrecruiter: this.props.isrecruiter,
          })
          .then((resp) => {
            let list = [];
            shouldCallAPI = true;
            isRefresh
              ? (list = [...resp.data.result])
              : (list = [...listdata, ...resp.data.result]);

            this.setState({
              listdata: list,
              data: true,
              backupList: resp.data.result,
              createmenu: false,
              fullcount: resp.data.result[0]
                ? parseInt(resp.data.result[0].count)
                : 1,
              offset: this.state.offset + this.state.limit,
            });
          });
      }
    }
  }

  updatePostData(postData) {
    this.setState({ postData });
  }

  // create() {
  //   return (
  //     !this.state.nofuel && (
  //       <Create
  //         {...this.props}
  //         {...this.state}
  //         tempdata={tempdata}
  //         getAllHiringPlan={this.getAllHiringPlan}
  //         postData={this.postData}
  //       />
  //     )
  //   );
  // }

  // const postData = {
  //   pipelineid: null,
  //   name: null,
  //   description: null,
  //   isdraft: false,
  //   isactive: true,
  //   noofstage: 0,
  //   pipelinestage: [],
  // }
  // this.setState(
  //   {
  //     // newpolicycreate: true,
  //     postData,
  //   },
  //   () => {
  //     this.props.history.push(`${this.props.match.path}/create`);
  //   },
  // );

  // async onCreate() {
  //   const postData = {
  //     hiringplanid: null,
  //     name: "",
  //     description: null,
  //     isactive: true,
  //     isapprovalrequired: false,
  //     owner: [],
  //     hiringmanager: null,
  //   };
  //   this.setState(
  //     {
  //       // newpolicycreate: true,
  //       postData,
  //     },
  //     () => {
  //       this.props.history.push(`${this.props.match.path}/create`);
  //     },
  //   );
  // }

  onCreate() {
    const POST_DATA = {
      hiringplanid: null,
      name: "",
      description: null,
      isactive: true,
      isapprovalrequired: false,
      owner: [],
      hiringplanpartner: [],
    };
    this.setState(
      {
        postData: POST_DATA,
        fullcount:
          this.state.listdata && this.state.listdata.length == 0 ? 1 : "",
        offset: 0,
      },
      () => {
        this.props.history.push(`${this.props.match.url}/hiring_plan/create`);
        // this.renderCreate();
      },
    );
  }

  onEdit() {
    const { selectedRow } = this.state;
    instance
      .get(`/recruit/gethiringplanbyid/${selectedRow.hiringplanid}`)
      .then((resp) => {
        console.log(resp.data.result[0]);
        // resp.data.result[0].participant = tempparticipant;
        this.setState(
          {
            postData: resp.data.result[0],
            createmenu: false,
            offset: 0,
            fullcount: "",
            // listdata: [],
          },
          () => {
            this.props.history.push(
              `${this.props.match.url}/hiring_plan/create`,
            );
          },
        );
      });
  }

  onDelete() {
    console.log(this.state.selectedRow);
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .get(`recruit/deletehiringplan/${selectedRow.hiringplanid}`)
              .then(
                () => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.props.closeSnackbar();
                  this.setState(
                    {
                      backupList: [],
                      fullcount: 1,

                      offset: 0,
                      createmenu: false,
                    },
                    () => {
                      this.getAllHiringPlan(true);
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                  this.props.closeSnackbar();
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        postData={this.state.postData}
        onCreate={true}
        updatePostData={this.updatePostData}
        getAllHiringPlan={this.getAllHiringPlan}
        getAllEmp={this.getAllEmp}
      />
    );
  }

  renderList() {
    const { ishiringmanager, ispipeline, open } = this.state;

    return (
      <div
        className="content-outer-wrapper-with-tab"
        onScroll={() => this.handleScroll1()}
      >
        {(this.state.listdata && this.state.listdata.length > 0) ||
        this.state.issearch ? (
          <div>
            {/* <Grid container className="margin-bottom-24" spacing={3}>
              <Grid item md={7} sm={12}></Grid>
              <Grid item md={3} sm={12}>
                <SearchSq
                  placeholder="Search"
                  value={this.state.searchValue}
                  onChange={this.searchHiring}
                />
              </Grid>
              {this.props.isrecruiter && (
                <Grid item md={2} sm={12} className="text-align-right">
                  {this.state.permissions.editable && (
                    <Button
                      variant="contained"
                      className="btn btn-primary-md-blue width100"
                      color="primary"
                      onClick={this.onCreate}
                    >
                      Create new
                    </Button>
                  )}
                </Grid>
              )}
            </Grid> */}

            <List
              // showOnlyList
              list={this.state.listdata}
              permissions={this.state.permissions}
              headers={this.state.headers}
              onCreate={this.props.isrecruiter && this.onCreate}
              onEdit={this.onEdit}
              // onPreview={this.onPreview}
              onDelete={this.onDelete}
              onStateStatusChange={this.onStateStatusChange}
              onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
              module="hiringplan"
            />
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ createmenu: false })}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onEdit}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onDelete}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Delete</span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
            <Drawer
              anchor="right"
              open={this.state.right}
              onClose={this.toggleDrawer("right", false)}
              classes={{
                paper: `${
                  ishiringmanager && "width30"
                } planner-drawer padding15 width30`,
              }}
            >
              <DrawerHeader
                header="Edit hiring manager"
                isbackarrow={false}
                closeDrawer={this.toggleDrawer("right", false)}
              />
              {ishiringmanager && (
                <div
                  className="padding-bottom-16 thin-scroll"
                  style={{ overflowY: "scroll", height: "90vh" }}
                >
                  <p className="normal-dark-secondary margin-bottom-4">
                    Select hiring helpers
                  </p>
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.currencyunicode || null,
                      placeholder: "",
                      label: "",
                      options: this.state.currenydropdown || [],
                    })}
                  />
                  <Grid container>
                    <Grid item md={11} sm={12}>
                      <div style={{ width: 32, marginRight: 8 }}>
                        <ProfilePicture
                          src={getFormattedImageLink()}
                          height="32"
                          classname="floatleft margin-right-16"
                        />
                      </div>

                      <div className="floatleft ">
                        <p className="small-dark-secondary  t-bold">designer</p>
                        <p className="small-dark-secondary  t-bold">
                          web-designer
                        </p>
                      </div>
                    </Grid>
                    <Grid item md={1} sm={12}>
                      <img
                        src={deleteicon}
                        className="cursor-pointer "
                        style={{ padding: 8 }}
                      ></img>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Drawer>
          </div>
        ) : (
          <div className="position-rel">
            <DefaultComp
              heading="There are no hiring plans to display"
              subheading="Get started by creating your first hiring plan!"
              imageSrc={empty}
            />
            {this.state.permissions.editable && (
              <div className="text-center margin-top-24">
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.onCreate}
                >
                  Create new
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      history: {
        location: { pathname = "" },
      },
    } = this.props;
    return (
      <div>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            {this.state.data &&
              pathname == "/app/recruit/hiring_plan" &&
              this.renderList()}
            {pathname == "/app/recruit/hiring_plan/create" &&
              this.renderCreate()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);

const POST_DATA = {
  hiringplanid: null,
  name: "",
  description: null,
  isactive: true,
  isapprovalrequired: false,
  owner: [],
  hiringplanpartner: [],
};
